import { IScreenPosition, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import doShoWPanelData from "../../../UIX/utils/doShowPanelData"
import { ID } from "src/libs/interfaces/layouts"
import updateSelectedPosition from "../utils/updateSelectedPosition"
 
const Transformer = () => {
}
export default Transformer
export interface ISelectedData {
    id: ID,
    sectionId: ID,
    selectedType: SELECT_TYPE,
    type: string
    bound: DOMRect
}
Transformer.setPosition = (position: IScreenPosition) => {
    const { editElement } = useLandingStore.getState()    
    // console.log( position, editElement )
    let positionContainer: HTMLDivElement | null, cont: HTMLDivElement | null
    switch (editElement.selectType) {
        case SELECT_TYPE.FLOAT: 
            positionContainer = document.querySelector(`[data-float-id=${editElement.id}]`)
            if(!positionContainer) break 
            positionContainer.style.top = (position.top || 0) + "px"
            positionContainer.style.left = (position.left || 0) + "px"
            positionContainer.style.transform = `scale(${ position.scale || 1 }) rotate(${ position.rotate || 0 }deg scale(1) skew( ${position.skewY || 0}deg, ${position.skewY || 0 }deg))`
            break;
        case SELECT_TYPE.CONTENT: 
            positionContainer = document.querySelector(`[data-meat-id=${editElement.id}]`) 
            if(!positionContainer) break 
            cont = positionContainer.closest(".landing-section-data-position")
            if(!cont) break            
            cont.style.transform = `rotate(${ position.rotate || 0 }deg) translateX(${ position.left }px) translateY(${ position.top }px) scale(1) skew( ${position.skewY || 0}deg, ${position.skewY || 0 }deg))`
            break
        case SELECT_TYPE.TITLE: 
        case SELECT_TYPE.DELIMITER: 
        case SELECT_TYPE.BACKGROUND: 
        default:
            break 
    } 

} 
Transformer.setSelected = ( data: ISelectedData ) => {
    useLandingStore.setState({ 
        selectedMeat: data.id,  
        selectedFloat: data.id, 
        selectedLayer: data.sectionId,                
        selectedType: data.selectedType,
        //
        editElement: {
            id: data.id,
            type: data.type,
            sectionId: data.sectionId, 
            selectType: data.selectedType,
            bound: data.bound
        }
    })
    doShoWPanelData(data.selectedType)
}